import { render, staticRenderFns } from "./Comunicados.vue?vue&type=template&id=457767a7&scoped=true&"
import script from "./Comunicados.vue?vue&type=script&lang=js&"
export * from "./Comunicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457767a7",
  null
  
)

export default component.exports